class removeFields {
    // This executes when the function is instantiated.
    constructor() {
        this.iterateLinks()
    }

    iterateLinks() {
        // Use event delegation to ensure any fields added after the page loads are captured.
        document.addEventListener('click', e => {
            console.debug(`removeFields click listener triggered.`, e)
            if (e.target && e.target.classList.contains('remove_fields')) {
                this.handleClick(e.target, e)
            }
        })
        // #152: the remove half of the readiness marker, and note it is a DIFFERENT SHAPE from the add
        // half on purpose — because the binding it reports is a different shape.
        //
        // addFields binds each `.add_fields` element directly, so its marker goes on the elements and
        // claims only those. This listener is DELEGATED to `document`: one handler, attached once, that
        // catches every `.remove_fields` click including rows cocoon inserts later. There is no
        // per-element fact to mark, so the marker goes on the object that actually got the handler —
        // the document — and it claims the stronger thing that delegation genuinely gives us: from here
        // on, every `.remove_fields` on this page works, present or future.
        //
        // `documentElement` and this listener have the SAME lifetime, which is why the marker cannot go
        // stale. Turbo Drive replaces `<body>` and merges `<head>`; it does not touch `<html>` — so the
        // attribute survives a Drive navigation, and so does the `document` listener. Compare
        // `data-js-ready`, which reads stale-true after a navigation precisely because the thing it
        // spoke for (Alpine components in the swapped body) does NOT survive while the marker does.
        //
        // Set AFTER addEventListener, so the marker can never be observable before the handler exists.
        // A marker that leads its handler is worse than no marker: it looks like a wait that worked.
        document.documentElement.setAttribute('data-remove-fields-ready', 'true')
    }

    handleClick(link, e) {
        // Stop the function from executing if a link or event were not passed into the function.
        if (!link || !e) return
        // Prevent the browser from following the URL.
        e.preventDefault()
        // Find the parent wrapper for the set of nested fields.
        let fieldParent = link.closest('.nested-fields')
        // If there is a parent wrapper, find the hidden delete field.
        let deleteField = fieldParent
            ? fieldParent.querySelector('input[type="hidden"]')
            : null
        // If there is a delete field, update the value to `1` and hide the corresponding nested fields.
        if (deleteField) {
            deleteField.value = 1
            fieldParent.style.display = 'none'
        }
    }
}

window.addEventListener('load', () => new removeFields())
// Wait for turbolinks to load, otherwise `document.querySelectorAll()` won't work
// NB: couldn't get turbolinks event to work :/
// -> `window.addEventListener('turbolinks:load', () => new removeFields())`
